<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XbpQMk/Images/cover.jpg?1701477356251" alt="This image is the cover for the book Eat, Drink and Be Buried, The Gourmet Detective Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eat, Drink and Be Buried, The Gourmet Detective Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>When a jousting match at a medieval fair turns into old-fashioned murder, the Gourmet Detective sets out to unmask the killer.</b><br/>  At Sir Gerald’s medieval festival, the castle is authentic, the jousting is rousing, and the wenches are the sauciest in the land. The only thing missing is decent food. And so Sir Gerald calls in London’s gourmet detective, an expert food finder, whose specialties include locating rare ingredients, designing historically accurate menus, and solving the occasional murder. And all three skills will be tested if he is to escape the age of chivalry alive. After the day’s first joust, the winning knight falls to the ground, poisoned. Someone is trying to exterminate the gentry of this ersatz fiefdom, and it will take a sure palate and a strong stomach to find out who. To save his own head, the detective must contend with flooding dungeons, stray arrows, and a cast of dwarf knights—all while struggling to design a menu fit for a king.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter King
      </h2>
      
      <p class="authorDescription body article">Peter King (b. 1922) is an English author of mystery fiction, a Cordon Bleu&ndash;trained chef, and a retired metallurgist. He has operated a tungsten mine, overseen the establishment of South America&rsquo;s first steel processing plant, and prospected for minerals around the globe. His work carried him from continent to continent before he finally settled in Florida, where he led the design team for the rocket engines that carried the Apollo astronauts to the moon.&#160;In his spare time, King wrote one-act plays and short mystery stories. When he retired, in 1991, he wrote his first novel, <i>The Gourmet Detective</i>, a cozy mystery about a chef turned sleuth who solves mysteries in the kitchen. King followed it with seven more books starring the character, including <i>Dying on the Vine </i>(1998) and <i>Roux the Day</i> (2002). In 2001 he published <i>Jewel of the North</i>, the first of three historical mysteries starring Jack London. King lives in Sarasota, Florida.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7563cbd2